module.exports = __webpack_public_path__ + "static/media/pru-horizontal-logo.21603db6.png";